/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation;
  if (!$nav.length) return;

  var activeClass = 'nav-hover'; // CSS still keys off this; keep for visual styling
  var CLOSE_DELAY = 300;         // ms grace period before hover-close fires
  var closeTimers = new WeakMap();

  // Top-level dropdown parents (li) and their trigger anchors
  var $topParents = $nav.children('li.site-nav--has-dropdown');
  var $topTriggers = $topParents.children('a');
  var $topLinkAll = $nav.children('li').children('a'); // every top-level <a>, dropdown or not

  // Mark every dropdown trigger (top-level and nested) with aria-expanded="false"
  $nav.find('.site-nav--has-dropdown > a').attr('aria-expanded', 'false');

  function getTrigger($parent) {
    return $parent.children('a').first();
  }

  function getSubmenuLinks($parent) {
    // Top-level: items can live in <ul.site-nav__dropdown> OR in the <div.site-nav__dropdown>
    // (vwo-camp-22 mega-menu variant). Grab all visible <a> descendants of either.
    return $parent.children('.site-nav__dropdown, ul.site-nav__dropdown, div.site-nav__dropdown').find('a').filter(':visible');
  }

  function openDropdown($parent) {
    clearTimeout(closeTimers.get($parent[0]));
    $parent.addClass(activeClass);
    getTrigger($parent).attr('aria-expanded', 'true');
    $('.sticky-header').removeClass('sticky-header-transformed');
  }

  function closeDropdown($parent) {
    $parent.removeClass(activeClass);
    getTrigger($parent).attr('aria-expanded', 'false');
    if ($('.' + activeClass).length === 0) {
      $('.sticky-header').addClass('sticky-header-transformed');
      $('.nav-open-overlay').remove();
    }
  }

  function closeAll() {
    $topParents.each(function() { closeDropdown($(this)); });
  }

  // ---- Mouse / touch ----
  $topParents.on('mouseenter', function() {
    var $parent = $(this);
    clearTimeout(closeTimers.get(this));
    closeAll();
    openDropdown($parent);
  });

  $topParents.on('mouseleave', function() {
    var $parent = $(this);
    var el = this;
    closeTimers.set(el, setTimeout(function() {
      // Don't close if focus has moved into the submenu
      if (!$.contains(el, document.activeElement)) {
        closeDropdown($parent);
      }
    }, CLOSE_DELAY));
  });

  // Click trigger: if dropdown is closed, open it (don't navigate); if open, allow navigation
  $topTriggers.on('click', function(evt) {
    var $parent = $(this).parent();
    if (!$parent.hasClass(activeClass)) {
      evt.preventDefault();
      closeAll();
      openDropdown($parent);
      // Add a click-outside overlay (legacy behaviour)
      if (!$('.nav-open-overlay').length) {
        $('#shopify-section-header').after('<div class="nav-open-overlay"></div>');
        $('.nav-open-overlay').on('click', function() {
          closeAll();
          $(this).remove();
        });
      }
    }
  });

  // ---- Keyboard ----
  $topTriggers.on('keydown', function(evt) {
    var $trigger = $(this);
    var $parent = $trigger.parent();
    var $links = getSubmenuLinks($parent);

    switch (evt.key) {
      case 'ArrowDown':
      case 'Down':
        evt.preventDefault();
        closeAll();
        openDropdown($parent);
        if ($links.length) $links.first().focus();
        break;
      case 'ArrowUp':
      case 'Up':
        evt.preventDefault();
        closeAll();
        openDropdown($parent);
        if ($links.length) $links.last().focus();
        break;
      case 'Enter':
      case ' ':
      case 'Spacebar':
        // Allow Enter on links to navigate, but Space toggles
        if (evt.key === ' ' || evt.key === 'Spacebar') {
          evt.preventDefault();
          if ($parent.hasClass(activeClass)) {
            closeDropdown($parent);
          } else {
            closeAll();
            openDropdown($parent);
            if ($links.length) $links.first().focus();
          }
        }
        break;
      case 'Escape':
      case 'Esc':
        if ($parent.hasClass(activeClass)) {
          evt.preventDefault();
          closeDropdown($parent);
        }
        break;
      case 'ArrowRight':
      case 'Right':
        evt.preventDefault();
        moveTopLevel($trigger, 1);
        break;
      case 'ArrowLeft':
      case 'Left':
        evt.preventDefault();
        moveTopLevel($trigger, -1);
        break;
    }
  });

  // Submenu link keyboard handling
  $nav.on('keydown', '.site-nav__dropdown a', function(evt) {
    var $link = $(this);
    var $parent = $link.closest('li.site-nav--has-dropdown').filter(function() {
      return $(this).parent('ul#AccessibleNav, ul.site-nav').length > 0;
    });
    // If we couldn't find a top-level parent in the cached nav, fall back to nearest top-level
    if (!$parent.length) $parent = $link.closest('.site-nav__dropdown').parent('li');
    if (!$parent.length) return;

    var $links = getSubmenuLinks($parent);
    var idx = $links.index($link);

    switch (evt.key) {
      case 'ArrowDown':
      case 'Down':
        evt.preventDefault();
        $links.eq((idx + 1) % $links.length).focus();
        break;
      case 'ArrowUp':
      case 'Up':
        evt.preventDefault();
        if (idx === 0) {
          getTrigger($parent).focus();
        } else {
          $links.eq(idx - 1).focus();
        }
        break;
      case 'Home':
        evt.preventDefault();
        $links.first().focus();
        break;
      case 'End':
        evt.preventDefault();
        $links.last().focus();
        break;
      case 'Escape':
      case 'Esc':
        evt.preventDefault();
        closeDropdown($parent);
        getTrigger($parent).focus();
        break;
      case 'ArrowRight':
      case 'Right':
        evt.preventDefault();
        closeDropdown($parent);
        moveTopLevel(getTrigger($parent), 1);
        break;
      case 'ArrowLeft':
      case 'Left':
        evt.preventDefault();
        closeDropdown($parent);
        moveTopLevel(getTrigger($parent), -1);
        break;
    }
  });

  // Close any open dropdown if focus leaves the nav entirely
  $nav.on('focusout', function() {
    setTimeout(function() {
      if (!$.contains($nav[0], document.activeElement)) {
        closeAll();
      }
    }, 0);
  });

  function moveTopLevel($currentTrigger, dir) {
    var idx = $topLinkAll.index($currentTrigger);
    if (idx < 0) return;
    var nextIdx = (idx + dir + $topLinkAll.length) % $topLinkAll.length;
    $topLinkAll.eq(nextIdx).focus();
  }
};

timber.drawersInit = function () {
  if (!timber.LeftDrawer) {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  } else {
    timber.LeftDrawer.init();
  }
  if (!timber.RightDrawer) {
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      
        'onDrawerOpen': ajaxCart.load
      
    });
  } else {
    timber.RightDrawer.init();
  }
};

timber.mobileNavToggle = function () {
  // Initialize aria-expanded on every per-section open/close button pair.
  $('.mobile-nav__toggle-open').attr('aria-expanded', 'false');
  $('.mobile-nav__toggle-close').attr('aria-expanded', 'true');

  timber.cache.$mobileSubNavToggle.off('click').on('click', function(evt) {
    var $wrapper = $(this).parent();
    var expanded = $wrapper.toggleClass('mobile-nav--expanded').hasClass('mobile-nav--expanded');
    $wrapper.find('.mobile-nav__toggle-open').attr('aria-expanded', expanded ? 'true' : 'false');
    $wrapper.find('.mobile-nav__toggle-close').attr('aria-expanded', expanded ? 'false' : 'true');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      element = options.element;

  // Selectors
  var $productImage = element.find('#ProductPhotoImg'),
      $addToCart = element.find('#AddToCart'),
      $productPrice = element.find('#ProductPrice'),
      $comparePrice = element.find('#ComparePrice'),
      $addToCartText = element.find('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
            var newImg = variant.featured_image,
          el = $productImage[0];
          timber.switchImage(variant.featured_image.src, variant.featured_image, el)
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      	$addToCartText.html("Add to Cart");
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      if (variant.name == "Owning the Wait by Jillian Tedesco") {
        $addToCartText.html("Out of Stock");
        $( "#AddToCartForm" ).after(function() {
          return "<div style='clear: both;'><p>Releasing April 4, 2022</p></div>";
        });
      } else {
        $addToCartText.html("Out of Season");
      }
    }

    // Regardless of stock, update the product price
    $productPrice.html('<span class="money">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>');

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>')
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
  }
  if (window.Currency) {
    window.Currency.convertAll(window.Currency.shopCurrency, window.Currency.currentCurrency);
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Called when a new product variant is selected
  var $el = $(el).closest('.product-single');

  var $newImage = $el.find('.product-single__photo[data-image-id="'+ imgObject.id +'"]');

  // Remove the wow fadeIn effect
  $el.find('.product-single__photo').removeClass('wow fadeIn').data('wow-delay', null).css({
      'visibility': 'visible',
      'animation-name': null,
  });

  scrollToImage();

  function scrollToImage() {
      var imageIndex = $newImage.parent().index();
      // Scroll to/reorder image unless it's the first photo on load
      if (imageIndex !== 0) {
          // Move selected variant image to top
          $('div.product-single__photos', $el).prepend($newImage.parent());
		  var owl = $el.find("#product-images-mobile");
		  owl.trigger('to.owl.carousel', imgObject.position-1);

		  var slider = $el.find('.homepage-sections--indiv-product-slider');
		  if (slider.length > 0) {
		    slider.flexslider(imgObject.position - 1);
		    // Do not scroll to section top
		    return;
		  }

		  $.smoothScroll({
		    offset: -$('.mobile-nav-bar-wrapper.sticky-header').outerHeight(),
		    scrollTarget: '#product-images-mobile'
		  });

		  var checkWidth = $(document).width();
		  if(checkWidth >=769){
			  $.smoothScroll({
		        offset: -$('.site-header.sticky-header').outerHeight(),
		        scrollTarget: 'div.product-single__photos'
		      });
			  return false;  
		  }
    }
  }  
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position + '-link',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    var self = this;
    $(this.config.open).off('click').on('click', function (evt) { self.open(evt); });
    this.$drawer.find(this.config.close).off('click').on('click', this.close.bind(this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Move focus to the overlay close button if present (it's the most
    // prominent close affordance, so keyboard users find it immediately).
    var $overlayClose = $('#DrawerOverlayClose');
    if ($overlayClose.length) {
      // setTimeout 0 lets the focus trap finish its initial focus() call first.
      setTimeout(function() { $overlayClose.trigger('focus'); }, 0);
    }

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Esc to close drawer (a11y)
    var self = this;
    this._escHandler = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        self.close();
      }
    };
    $(document).on('keydown.drawer-' + this.config.dirOpenClass, this._escHandler);

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Tear down Esc handler
    $(document).off('keydown.drawer-' + this.config.dirOpenClass);

    // Reset aria-expanded on the trigger that opened the drawer
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
      // Restore focus to the trigger
      this.$activeSource.trigger('focus');
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      // Allow focus inside the drawer container itself OR inside #DrawerOverlay
      // (which lives outside the transformed drawer DOM and hosts the close button).
      var inContainer = $container[0] === evt.target || $container.has(evt.target).length;
      var overlay = document.getElementById('DrawerOverlay');
      var inOverlay = overlay && (overlay === evt.target || overlay.contains(evt.target));
      if (!inContainer && !inOverlay) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
document.addEventListener('shopify:section:load', timber.init);
